import React, {useEffect, useLayoutEffect} from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import LottieLoader from "../../LottieLoader";
import lottieLoaderFile from "../../../files/animation/loading.json";
import lottieEmptyFile from "../../../files/animation/empty_new.json";
import Swal from "sweetalert2";
import paginationFactory from "react-bootstrap-table2-paginator";
import { getFileIconClass } from "../../../constants/general.constant";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row
} from "reactstrap";

function EducationList(props) {
  const dispatch = useDispatch();
  const { data = [], limit = 0, page = 0, totalPages = 0, totalCount = 0 } = props.educationMaterialData
  const { userDetails } = useSelector(state => state.user);

  // Call unread count API on component mount
  useEffect(() => {
    dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
  }, []);
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    page: parseInt(page || 0),
    sizePerPage: parseInt(limit || 0),
    totalSize: parseInt(totalCount || 0),
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    hideSizePerPage: parseInt(totalCount) == 0 ? true : false, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    showTotal: parseInt(totalCount) == 0 ? false : true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "25",
        value: 25,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const rowStyle = (row, rowIndex) => {
    return {
      backgroundColor: !row.isActive ? '#eeeeee' : undefined,
    };
  };
  
  function handleEdit(row) {
    props.handleEdit(row);
  }

  return (
    <Row className="col-sm-12 main-cls-modal remove-table-padding">
    <Col sm="12" className="mt-12" style={{overflowX : 'auto'}}>
    <div className="scrollbar-table-cls">
      <BootstrapTable
        remote={{
          sort: false,
          pagination: true,
          filter: true,
          search: true,
        }}
        wrapperClasses="table-responsive"
        keyField="_id"
        noDataIndication={() => {
          return (
            <div>
              {props.loading && (
                <LottieLoader
                  loadLoop={true}
                  autoplayLoop={true}
                  source={lottieLoaderFile}
                  Lheight={150}
                  Lwidth={150}
                  subTitle={"Please Wait ..."}
                />
              )}
              {!props.loading && (
                <LottieLoader
                  loadLoop={true}
                  autoplayLoop={true}
                  source={lottieEmptyFile}
                  Lheight={300}
                  Lwidth={300}
                  title={"Sorry! No data found"}
                  subTitle={"We can't find any educational material data."}
                />
              )}
            </div>
          );
        }}
        data={data}
        columns={[
          {
            dataField: "materialType",
            text: "Material Type",
            sort: true,
            formatter: (cell) => <p>{cell ? cell : "-"}</p>,
            headerStyle: (colum, colIndex) => {
              return { width: '20%', textAlign: 'left' };
            },
          },
          {
            dataField: "note",
            text: "Note",
            sort: true,
            formatter: (cell) => <p>{cell ? cell : "-"}</p>,
            headerStyle: (colum, colIndex) => {
              return { width: '20%', textAlign: 'left' };
            },
          },
          {
            dataField: "files",
            text: "Educational Documents",
            sort: false,
            formatter: (cell) => {
              if (cell && cell.length > 0) {
                return (
                  <>
                    {cell.map((item, index) => {
                      const { icon, color } = getFileIconClass(item.name);
                      return (
                        <div key={index} className="link-hover">
                          <a
                            href={`${process.env.REACT_APP_VIDEO_CALL_REQUEST}/${item.path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <p style={{ display: "flex", alignItems: "center" }}>
                              <i
                                className={icon}
                                style={{ fontSize: 20, color, marginRight: 6 }}
                              ></i>
                              <span
                                style={{
                                  color: "#000000",
                                  textDecoration: "underline",
                                  fontWeight: 200,
                                  display: "inline-block",
                                  maxWidth: "350px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={item.name}
                              >
                                {item.name}
                              </span>
                            </p>
                          </a>
                        </div>
                      );
                    })}
                  </>
                );
              } else {
                return "-";
              }
            },
            headerStyle: (colum, colIndex) => {
              return { width: '15%', textAlign: 'left' };
            },
          },
          {
            dataField: "materialLink",
            text: "Educational Material Link",
            sort: false,
            formatter: (cell) => {
              if (cell && cell.length > 0) {
                return (
                  <>
                    {cell.map((item, index) => (
                      <div key={index} className="link-hover">
                        <a
                          href={item}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <p style={{ display: "flex", alignItems: "center" }}>
                            <i
                              className="mdi mdi-link mr-2"
                              style={{ fontSize: 20, color: "blue", marginRight: 6 }}
                            ></i>
                            <span
                              style={{
                                color: "#000000",
                                textDecoration: "underline",
                                fontWeight: 200,
                                display: "inline-block",
                                maxWidth: "350px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={item}
                            >
                              {item}
                            </span>
                          </p>
                        </a>
                      </div>
                    ))}
                  </>
                );
              } else {
                return "-";
              }
            },
            headerStyle: (colum, colIndex) => {
              return { width: '12%', textAlign: 'left' };
            },
          },
          {
            dataField: "createdAt",
            text: "Created At",
            sort: true,
            formatter: (cell) => (
              <p>
                {cell ? moment(cell).format("MMMM DD, YYYY") : "-"}
              </p>
            ),
            headerStyle: (colum, colIndex) => {
              return { width: '10%', textAlign: 'left' };
            },
          },
          {
            dataField: "createdBy",
            text: "Created By",
            sort: true,
            formatter: (cell) => <p>{cell ? cell.fname + " " + cell.lname : "-"}</p>,
            headerStyle: (colum, colIndex) => {
              return { width: '10%', textAlign: 'left' };
            },
          },
          {
            dataField: "test",
            text: "Action",
            sort: false,
            headerStyle: (colum, colIndex) => {
              return { width: "5%", textAlign: "left" };
            },
            formatter: (cell, row, rowIndex) => {
              return (
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className="btn btn-sm me-2 mr-1"
                    style={{ borderRadius: "8px", background: '#4caf50', color: 'white' }}
                    onClick={() => handleEdit(row)}
                    title="Edit"
                  >
                    <i
                      className="mdi mdi-pencil"
                      style={{ fontSize: "15px", color: 'white' }}
                    /> Edit
                  </button>
                  {row.isActive ? (
                    <button
                      className="btn btn-sm"
                      style={{ borderRadius: "8px", background: '#d33', color: 'white' }}
                      disabled={userDetails?.role === "admin" ? false : userDetails._id.toString() === row.createdBy._id.toString() ? false : true}
                      onClick={() =>
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You want to deactivate this educational material type?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                          cancelButtonText: "No",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            props.handleDelete(row);
                          }
                        })
                      }
                      title="Inactive"
                    >
                      <i
                        className="mdi mdi-close"
                        style={{ fontSize: "15px", color: 'white' }}
                      /> Inactive
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm"
                      style={{ borderRadius: "8px", background: '#4caf50', color: 'white' }}
                      onClick={() =>
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You want to activate this educational material type?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                          cancelButtonText: "No",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            props.handleDelete(row);
                          }
                        })
                      }
                      title="Activate"
                    >
                      <i
                        className="mdi mdi-check-circle"
                        style={{ fontSize: "15px", color: 'white' }}
                      /> Activate
                    </button>
                  )}
                </div>
              );
            },
          },
        ]}
        pagination={options.page > 0 ? paginationFactory(options) : undefined}
        bordered
        rowStyle={rowStyle}
        onTableChange={props.pagination}
      ></BootstrapTable>
    </div>
    </Col>
    </Row>
  );
}

export default EducationList;
